export var IMG_URLS = {
  IOS: 'https://static.beeline.ru/upload/images/app/23217-AppStoreLight.svg',
  IOS_FULL: 'https://static.beeline.ru/upload/images/app/23217-AppStoreFullLight.svg',
  ANDROID: 'https://static.beeline.ru/upload/images/app/23217-GoogleStore.svg',
  HUAWEI: 'https://static.beeline.ru/upload/images/app/23217-HuaweiStore.svg',
  RU_STORE: 'https://static.beeline.ru/upload/images/app/23217-RuStore.svg'
};